<script>
  import { renderable } from './three-viz.js'
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

  export let maxPolarAngle = Math.PI * 0.5
  export let target = [0, 0, 0]

  let controls

  renderable({
    setup: props => {
      const { camera, canvas } = props

      controls = new OrbitControls(camera, canvas)
      controls.maxPolarAngle = maxPolarAngle
      controls.target.set(target[0], target[1], target[2]);

    },
    render: () => {
      controls.update()
    },
  })
</script>
